import { render } from "./ReviewPosts.vue?vue&type=template&id=d66b840c&scoped=true"
import script from "./ReviewPosts.vue?vue&type=script&lang=js"
export * from "./ReviewPosts.vue?vue&type=script&lang=js"

import "./ReviewPosts.vue?vue&type=style&index=0&id=d66b840c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d66b840c"]])

export default __exports__